import { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { TGetReportFiltersResponse, TReportFilterPayload, TReportKey } from '../types';

export class ReportService {
  /**
   * Get Report Filter Options
   * @returns TGetReportFiltersResponse
   */
  public static getFilterOptions(
    report: TReportKey,
    filters: TReportFilterPayload = {}
  ): CancelablePromise<TGetReportFiltersResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: `/reports/${report}/filters`,
      body: filters,
    });
  }

  /**
   * Export Report
   * @returns Blob
   */
  public static exportReport(report: TReportKey, filters: TReportFilterPayload = {}): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: `/reports/${report}/export`,
      body: filters,
      responseType: 'blob',
    });
  }
}
